var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonDemandReceiptMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4218_2889)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56705 27.9938L1.53189 25.9462C1.2837 25.7104 1.2837 25.3133 1.51948 25.0776L3.56705 23.03L1.51948 20.9948C1.27129 20.7466 1.27129 20.3619 1.51948 20.1138L3.56705 18.0662L1.51948 16.031C1.27129 15.7828 1.27129 15.3981 1.51948 15.1499L3.56705 13.1024L1.53189 11.0548C1.34575 10.8811 1.29611 10.6205 1.39538 10.3847C1.49466 10.1489 1.71803 10 1.96622 10H31.7491H36.7129C37.0603 10 37.3333 10.273 37.3333 10.6205V30.4757C37.3333 30.8232 37.0603 31.0962 36.7129 31.0962H31.7491H1.96622C1.71803 31.0962 1.49466 30.9473 1.39538 30.7115C1.29611 30.4757 1.34575 30.2151 1.51948 30.0414L3.56705 27.9938ZM36.0924 11.241H32.3695V29.8552H36.0924V11.241ZM11.413 20.0801C11.413 16.1087 14.6417 12.8801 18.613 12.8801C22.5844 12.8801 25.813 16.1087 25.813 20.0801C25.813 24.0515 22.5844 27.2801 18.613 27.2801C14.6417 27.2801 11.413 24.0515 11.413 20.0801ZM19.7195 17.5791H21.2353L21.2203 17.5791V16.4877H15.9908V17.6397L17.6279 17.6396C18.219 17.6396 18.7192 17.9883 18.9314 18.5036H15.9908V19.595H18.9314C18.7192 20.0952 18.219 20.459 17.6279 20.459H15.9908V21.8536L18.6434 24.5365L20.2502 24.5364L17.3702 21.611H17.6278C18.8556 21.611 19.8863 20.7469 20.1288 19.5949L21.2353 19.5951V18.5037H20.1288C20.053 18.1702 19.9166 17.8518 19.7195 17.5791Z",
    fill: "#F59E0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4218_2889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonDemandReceiptMenu);
export default __webpack_public_path__ + "static/media/NonDemandReceiptMenu.3ced6e67762b986b926b155e620fc419.svg";
export { ForwardRef as ReactComponent };